module.exports = __webpack_public_path__ + "img/logo.d52a1c35.png";